var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamtasiaScreencastLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CamtasiaScreencastLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#CamtasiaScreencastLogo_svg__b)",
  d: "M18.047 0H1.953A1.953 1.953 0 0 0 0 1.953v16.094C0 19.126.874 20 1.953 20h16.094A1.953 1.953 0 0 0 20 18.047V1.953A1.953 1.953 0 0 0 18.047 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m10.675 14.028-5.646-3.774-.01-.003q-.005 0-.009.002a.02.02 0 0 0-.009.016v6.793a.438.438 0 0 0 .684.362z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCE2C9",
  d: "M7.51 8.745 5 10.236l5.675 3.791 2.327-1.584z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.06 9.638 5.684 2.576A.437.437 0 0 0 5 2.938v4.149a.02.02 0 0 0 .008.014l7.984 5.334.01.003.01-.003 3.047-2.075a.438.438 0 0 0 0-.722"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#CamtasiaScreencastLogo_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#CamtasiaScreencastLogo_svg__d)",
  d: "M28.125 10C29.16 10 30 10.84 30 11.875v16.25C30 29.16 29.16 30 28.125 30h-16.25A1.875 1.875 0 0 1 10 28.125v-16.25c0-1.036.84-1.875 1.875-1.875z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m16.42 12.175-2.878 3.033h10.04a.3.3 0 0 0 .208-.091l2.372-2.5a.32.32 0 0 0 .066-.336.31.31 0 0 0-.274-.198H16.63a.3.3 0 0 0-.21.092M16.42 27.408l-2.878-3.033h10.04a.3.3 0 0 1 .208.092l2.372 2.499a.32.32 0 0 1 .066.337.31.31 0 0 1-.274.197H16.63a.3.3 0 0 1-.208-.092"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.458 15.208h-2.916v9.167h2.916z",
  opacity: 0.74
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CamtasiaScreencastLogo_svg__b",
  x1: 10,
  x2: 10,
  y1: 0,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A731"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EE7B2E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CamtasiaScreencastLogo_svg__d",
  x1: 10,
  x2: 10,
  y1: 10,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#97C93D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D9544"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "CamtasiaScreencastLogo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "CamtasiaScreencastLogo_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10 10h20v20H10z"
})))));
export default SvgCamtasiaScreencastLogo;